import { render, staticRenderFns } from "./calendarMonth.vue?vue&type=template&id=480baae8&"
import script from "./calendarMonth.vue?vue&type=script&lang=js&"
export * from "./calendarMonth.vue?vue&type=script&lang=js&"
import style0 from "./calendarMonth.vue?vue&type=style&index=0&id=480baae8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports